import FacebookIcon from "@/components/icons/socials/facebook";
import InstagramIcon from "@/components/icons/socials/instagram";
import LinkedInIcon from "@/components/icons/socials/linkedin";
import YouTubeIcon from "@/components/icons/socials/youtube";
import { SocialType } from "@/lib/cms/cms-types";

export const socialToIcon = {
  FACEBOOK: FacebookIcon,
  INSTAGRAM: InstagramIcon,
  YOUTUBE: YouTubeIcon,
  LINKEDIN: LinkedInIcon,
} as const satisfies Record<SocialType, React.FC>;
